import { Pipe, PipeTransform } from '@angular/core';
import { ConversionDateTimeService } from '../services/conversion/conversion-datetime.service';

@Pipe({ name: 'formatTodayOrDate' })
export class FormatTodayOrDatePipe implements PipeTransform {
    constructor(private conversionDateTime: ConversionDateTimeService) {}

    transform(value: Date | string | number, format: 'date' | 'datetime' = 'datetime', timezoneOffset?: number | null): string {
        if (!value) return '';
        if (timezoneOffset != null) {
            return this.conversionDateTime.convertDateTimeOffset(value, timezoneOffset, format === 'datetime');
        }
        return format === 'date'
            ? this.conversionDateTime.convertDate(value)
            : this.conversionDateTime.convertDateTime(value);
    }
}
